import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, Image, Paragraph, Separator } from '@fs/zion-ui'
import { setOptInOut } from '@fs/zion-soft-launch'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useR2DispatchContext } from '../../../../../providers/r2Provider/R2Context'
import IndexingIllustration from './IndexingIllustration.png'

const DisableAttachFlowFlagOverlay = ({ overlay }) => {
  const [t] = useTranslation()
  const r2Dispatch = useR2DispatchContext()
  const { openOverlay } = useOverlayContext()
  return (
    <DialogOverlay {...overlay} title={t('disable-attach-flow-flag-overlay.title', 'Disable Feature')}>
      <Image src={IndexingIllustration} />
      <Separator size="sm" />
      <Paragraph size="sm">
        {t(
          'disable-attach-flow-flag-overlay.content1',
          'You are about to disable the new process that allows you to add names and events to accurately build and improve your tree.'
        )}
      </Paragraph>
      <Paragraph size="sm">
        {t(
          'disable-attach-flow-flag-overlay.content2',
          'After you click disable, please send us feedback by clicking the Feedback button on the left side. Thank you.'
        )}
      </Paragraph>
      <DialogOverlayActions>
        <Button
          onClick={overlay.close}
          linkName="Disable Attach Flow Flag Overlay Cancel"
          data-testid="disable-attach-flow-flag-cancel"
        >
          {t('disable-attach-flow-flag-overlay.cancel-btn', 'Cancel')}
        </Button>
        <Button
          emphasis="high"
          onClick={() => {
            overlay.close()
            setOptInOut({
              newPref: false,
              featureFlag: 'rip_sharedImageViewer_fullTextAttachFlow_v1',
              reloadPage: false,
            })
            r2Dispatch({
              type: 'SET_ATTACH_FLOW_OPT_IN_LOCAL_CHANGE',
              value: false,
            })
            openOverlay('mainInfosheet')
            openOverlay('attachToTreeOverlay')
          }}
          linkName="Disable Attach Flow Flag Overlay Disable"
          data-testid="disable-attach-flow-flag-disable"
        >
          {t('disable-attach-flow-flag-overlay.disable-btn', 'Disable')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}

export default DisableAttachFlowFlagOverlay
